<template>
	<div class="container py-5">
		<div class="row justify-content-center">
			<div class="col-lg-8">
				<!-- Success Card -->
				<div class="card shadow-sm border-success mb-4">
					<div class="card-header bg-success text-white">
						<h3 class="my-2">
							<i class="bi bi-x" />
							Report Not Found
						</h3>
					</div>
					<div class="card-body p-4">
						<div class="text-center mb-4">
							<div class="alert alert-info py-3">
								<strong>Your Report ID: </strong>
								<span class="fs-4 fw-bold">{{ id }}</span>
							</div>
							<p>
								Sorry, looks like this isn't a report ID number that we
								recognize. If you're seeing this after clicking on a link,
								please
								<a href="mailto:support@report.mosquitoes.online">let us know</a
								>. If you're seeing this after typing something in, you probably
								want to double-check what you typed.
							</p>
							<img src="/static/img/anti-mosquito-sign.jpg" width="256" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
interface Props {
	id: string;
}
const props = defineProps<Props>();
</script>
